import React from 'react';
import { useTranslation } from 'react-i18next';
import { EMPTY_VALUES } from '../../../../../../Apis/functions';
import ResumeInfoCard from '../../../../../../components/ResumeInfoCard';
import NotInformation from '../../../../../../components/NotInformation';
import { IconFingerprint, IconPersonPhoto } from '../../../../../../components/buttons/IconButtons';
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const SummaryFingerprintCard = ({ mergedFingerprints }) => {
    const { t } = useTranslation();
    return (
        <ResumeInfoCard
            title={t('fingerprint')}
            titleIcon={<IconFingerprint width={24} height={24} />}
            icon={<IconPersonPhoto className='btn-icon-svg-24px' />}
            iconClass='background-primary-100'
            contentClass={"py-3"}
            body={
                <div className='row px-0'>
                    {mergedFingerprints?.length > 0 ? (
                        mergedFingerprints.map((print, index) => (
                            <div key={index} className='col-12 col-md-6 mb-2'>
                                <div className='d-flex justify-content-between align-items-center p-2 background-shades-50 border-radius-8px'>
                                    <div className='fs-12px ibl-font-w-600 font-color-general-950'>
                                        {print?.name || EMPTY_VALUES.DEFAULT}
                                    </div>
                                    <div className='d-flex gap-3 fs-14px ibl-font-w-400 font-color-shades-800'>
                                        <span><IconFingerprint /></span>
                                        <span>{t('fingerprint')}</span>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className='col-12 px-0'>
                            <NotInformation text={t('no_information')} card={true}/>
                        </div>
                    )}
                </div>
            }
        />
    );
};

export default SummaryFingerprintCard;
